import {
  BUSINESS_TYPE_SUCCESS,
  BUSINESS_TYPE_FAILED,
  RESET_BUSINESS_TYPE,
  LOADING_BUSINESS_TYPE,
  NETWORK_ERROR_BUSINESS_TYPE,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetBusinessType = () => {
  return { type: RESET_BUSINESS_TYPE };
};

const getBusinessType = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_BUSINESS_TYPE });
  await partnerServices
    .post("getBusinessType", userData, { headers: { AuthToken: authTokenIs } })

    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(businessTypesuccess(res.data));
          // history.push({ pathname: "/index/homepage" });
          break;
        default:
          dispatch(businessTypefailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_BUSINESS_TYPE, payload: err });
    });
};

function businessTypesuccess(data) {
  return {
    type: BUSINESS_TYPE_SUCCESS,
    payload: data,
  };
}

function businessTypefailed(data) {
  return {
    type: BUSINESS_TYPE_FAILED,
    payload: data,
  };
}

export { resetBusinessType, getBusinessType };
